import React from "react";
import { useNavigate } from "react-router-dom";
import "../style/admin.css";

function Admin() {
  const navigate = useNavigate();

  return (
    <div className="admin-dashboard-wrapper">
      {/* Navbar */}
      <nav className="admin-nav-bar">
        <div className="admin-nav-logo">🏢</div>
      </nav>

      {/* Main Content */}
      <div className="admin-dashboard-content">
        <div className="admin-dashboard-text">
          <h2 className="admin-dashboard-welcome">Welcome, Admin!</h2>
          
          <div className="admin-dashboard-options">
            {/* Row 1 */}
            <div className="admin-dashboard-row">
              {/* Resident Management */}
              {/* <div className="admin-dashboard-box">
                <h1 className="admin-dashboard-heading">Resident Management</h1>
                <p className="admin-dashboard-description">
                  Add, edit, and manage resident details efficiently.
                </p>
                <button 
                  className="admin-dashboard-btn" 
                  onClick={() => navigate("/resident")}
                >
                  Manage Residents
                </button>
              </div> */}

              {/* Reports */}
              <div className="admin-dashboard-box">
                <h1 className="admin-dashboard-heading">Reports</h1>
                <p className="admin-dashboard-description">
                  View paid bills and generate wing-wise reports.
                </p>
                <button 
                  className="admin-dashboard-btn" 
                  onClick={() => navigate("/adminreport")}
                >
                  View Reports
                </button>
              </div>
            </div>

            {/* Row 2 */}
            <div className="admin-dashboard-row">
              {/* Staff Management */}
              {/* <div className="admin-dashboard-box">
                <h1 className="admin-dashboard-heading">Staff Management</h1>
                <p className="admin-dashboard-description">
                  Add and assign roles to office and field executives.
                </p>
                <button 
                  className="admin-dashboard-btn" 
                  onClick={() => navigate("/staff")}
                >
                  Manage Staff
                </button>
              </div> */}

              {/* Property & Hierarchy Management */}
              {/* <div className="admin-dashboard-box">
                <h1 className="admin-dashboard-heading">Property Management</h1>
                <p className="admin-dashboard-description">
                  Organize and manage property hierarchy seamlessly.
                </p>
                <button 
                  className="admin-dashboard-btn" 
                  onClick={() => navigate("/property")}
                >
                  Manage Properties
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Navigation */}
      {/* <footer className="admin-dashboard-footer">
        <button className="admin-dashboard-nav-btn" onClick={() => navigate("/admin")}>
          Home
        </button>
        <button className="admin-dashboard-nav-btn" onClick={() => navigate("/resident")}>
          Residents
        </button>
        <button className="admin-dashboard-nav-btn" onClick={() => navigate("/adminreport")}>
          Reports
        </button>
      </footer> */}

      <div className="footer">
        <p>powered by @Dexpert Systems</p>
      </div>
    </div>
  );
}

export default Admin;
